import React from 'react';
import Header from '../../header/Header';
import Footer from '../../footer/Footer';
import ScrollToTop from 'react-scroll-up';

export default ({ children }) => {
  return (
    <div>
      <Header headerPosition="header--fixed logoresize" logo="dark" color="color-black" />
      <div className="page-container">{children}</div>
      <Footer />
      <div className="backto-top">
        <ScrollToTop showUnder={160}>
          {/* <FiChevronUp /> */}
          <img src="/assets/images/icons/backtotop.svg" alt="Noctil" />
        </ScrollToTop>
      </div>
    </div>
  );
};
